'use strict';

angular.module('TurneroApp').service('preguntasService', [
    '$resource',
    'portal',
    function ($resource, portal) {

        return $resource(portal.getUrlServer() + 'api/Pregunta/:id', { id: '@Id_Opcion_Calificacion' }, {
            get: {
                method: 'GET',
                params: {
                    id_Pregunta: '@id_Pregunta'
                },
                url: portal.getUrlServer() + 'api/Pregunta/GetInfo/',
            },
            getfiltro: {
                method: 'GET',
                withcredentials: true,
                params: {
                    nro_Pagina: '@nro_Pagina',
                    tam_Pagina: '@tam_Pagina',
                    texto: '@texto'
                },
            },
            save: {
                method: 'POST',
            },
            'delete': {
                method: 'DELETE',
            },
            update: {
                method: 'PUT'
            },
            Get_Tipos_Respuesta: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Pregunta/Get_Tipos_Respuesta/',
                //isArray: true,
            },
            Get_Opciones_Respuesta: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Pregunta/Get_Opciones_Respuesta/',
                //isArray: true,
            },
            Guardar_Orden_Preguntas: {
                method: 'POST',
                url: portal.getUrlServer() + 'api/Pregunta/Guardar_Orden_Preguntas/',
                params: {
                    nro_Pagina: '@nro_Pagina',
                    tam_Pagina: '@tam_Pagina',
                },
            }
        });
    }]);



// WEBPACK FOOTER //
// ./app/components/preguntas/preguntasService.js